<template>
    <my-form v-model="form" table>
        <el-form-item label="审核意见" class="table-full-row">
            <el-input v-model="shenheyj" type="textarea" :rows="4"></el-input>
        </el-form-item>
        <template slot="btn" class="btn">
            <div v-if="cakeybj">
                <ca-activation type="danger" icon="el-icon-circle-close" @click="funSend('3',$event)">
                    退回
                </ca-activation>
                <ca-activation type="primary" icon="el-icon-circle-check" @click="funSend('9',$event)">
                    通过
                </ca-activation>
            </div>
            <div v-if="!cakeybj">
                <el-button icon="el-icon-circle-close" type="danger" @click="funSend('3')">
                    退回
                </el-button>    
                <el-button icon="el-icon-circle-check" type="primary" @click="funSend('9')">
                    通过
                </el-button>
            </div>
            

        </template>
    </my-form>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";

import CaActivation from '@/components-sys/ca-activation'
import '@/js/ca/hebei/hebcaP11Object2.js'
import '@/js/ca/CAbase.js'

export default {
    mixins: [FORM_PAGE_MIXIN],
    components: {
        CaActivation,
    },
    props: {
        row: {
            type: Object,
        },
    },
    data() {
        var that = this;
        return {
            form:{
                shyj:'',
                shbj:'',
                rows : that.row.ggcode,
				sData : "",
				sCert : "",
				cadwname : "",
				zbprocode : that.row.zbprocode,
                caType:''
            },
            cakeybj:'',
            dwname:'',
            caObjectVal:{},
            shenheyj:''
        };
    },
    methods: {
        // 通过 退回按钮
        funSend(shbj,data) {
            var that = this
            that.form.shyj = escape(escape(that.shenheyj))
            that.form.shbj = shbj
            // 判断是否退回
            if(shbj==='3'&&!that.form.shyj){
                ShowMsg('请填写退回意见！','error');
                return;
            }else{
                // 判断是否需要ca锁
                if(that.cakeybj){
                    that.form.caType = data
                    that.caObjectVal.character = that.form.shbj+ "$$$" + that.form.shyj + "$$$" + that.form.rows;
                    //签名
                    useCA(that.form.caType, 'sign', that.caObjectVal, function (res) {
                        that.form.sData = res.signData;
                         //获取证书对象
                        useCA(that.form.caType, 'getCertB64', that.objectVal, function (res) {
                            that.form.sCert = res.signCert;
                            //ca单位名称
                            useCA(that.form.caType, 'getcadwname', that.objectVal, function (res) {
                                that.form.cadwname = res.cadwname;
                                if (that.dwname == res.cadwname) {
                                    that.postSh()
                                }else{
                                    ShowMsg('CA单位名称与当前登录单位名称不一致！', 'error');
                                }
                            })
                        })
                    })
                }else{
                    that.postSh()
                }
            }
        },
        // 审核提交
        postSh(){
            var that = this
            that.$post(`${this.getGetters('mngUrl')}/manage/business/AuditZbgg/sh.json`, that.form, (data, res) => {
                ShowMsg('审核成功', 'success');
                that.$emit('cancle');
            });
        }
    },
    mounted() {
        var that = this
        // 获取是否需要CA锁
        that.$get(`${this.getGetters('mngUrl')}/manage/business/AuditZbgg/getCaBj.json`, {
            zbprocode:that.row.zbprocode
        }, (data, res) => {
            that.cakeybj = data.isCaBj
            that.dwname = data.dwCnName
        });
    }
};
</script>

<style lang="scss" scoped>
</style>